import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import styled from 'styled-components';
import { useClipboard } from 'use-clipboard-copy';

export interface IModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
}

const SocialShareModal = ({
  open,
  setOpen,
  ...args
}: Omit<IModalProps, 'children'> & {
  title?: string;
  url: string;
}) => {
  const { copy, copied } = useClipboard({
    copiedTimeout: 600,
  });

  const hadlerCopy = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    copy(args.url);
    e.stopPropagation();
  };
  return (
    <Container onClick={() => setOpen(!open)} open={open}>
      <div>
        <div>
          <WhatsappShareButton {...args} title={`Seja bem vindo a minha vaquinha:`}>
            <WhatsappIcon size={50} round />
          </WhatsappShareButton>
          <FacebookShareButton {...args}>
            <FacebookIcon size={50} round />
          </FacebookShareButton>
          <TwitterShareButton {...args}>
            <TwitterIcon size={50} round />
          </TwitterShareButton>
          <LinkedinShareButton {...args}>
            <LinkedinIcon size={50} round />
          </LinkedinShareButton>
          <TelegramShareButton {...args}>
            <TelegramIcon size={50} round />
          </TelegramShareButton>
        </div>
        <div>
          <div>
            <strong>{args.url}</strong>
          </div>
          <button onClick={hadlerCopy}>{copied ? 'Copiado' : 'Copiar'}</button>
        </div>
      </div>
    </Container>
  );
};

interface IModal {
  open: boolean;
}

const Container = styled.div<IModal>`
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  position: fixed;
  height: 100%;
  width: 100%;
  text-align: left;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.5s ease;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;

  & button {
    color: #0088cc;
    padding: 8px 30px;
    background-color: transparent;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    font-weight: bold;

    &[disabled] {
      background-color: rgba(217, 217, 217, 1);
    }
  }

  & > div {
    border-radius: 1rem;
    background-color: white;
    display: flex;
    flex-direction: column;
    max-width: 90%;
    & > div {
      &:first-child {
        align-self: center;
        padding: 1.5rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10;
        & > * {
          margin: 0 0.5rem;
        }
      }
      &:last-child {
        position: relative;
        margin: 1.5rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 10pt;
        & > div {
          margin-top: 0;
          background-color: #231f20;
          color: white;
          padding: 1rem;
          border-radius: 0.5rem;
          overflow: auto;

          & * {
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 5rem;
          }
        }
        & > *:last-child {
          position: absolute;
          right: 0;
          background-color: white;
          padding: 0.3rem 0.5rem;
          margin-right: 0.3rem;
          border-radius: 0.5rem;
        }
      }
    }
  }
`;

export default SocialShareModal;
